import { EventDetailsProps } from '@vista/omnichannel-components-ui/lib/src/lib/components/event'
import { EventDetailsPropsFromBe } from '../../types'

export function eventDetailsProps(props: EventDetailsPropsFromBe, scrollIntoView: () => void): EventDetailsProps {
    let eventDetailsProps = {
        //eventId: props.workflow.entityIds.eventId,
        displayText: props.displayText,
        config: {
            actionButton: props.config.actionButton,
            poster: {
                show: false,
            },
        },
        assets: {
            scheduleIconName: 'calendar',
        },
        cdnOptions: {
            heroBannerImage: { width: 1920 },
            posterImage: { width: 200 },
        },
        events: {
            onActionButtonClicked: () => {
                scrollIntoView()
            },
        },
    }

    /*@ts-ignore*/
    delete eventDetailsProps.displayText.failedToLoadDataTitle

    /*@ts-ignore*/
    delete eventDetailsProps.displayText.failedToLoadDataMessage
    

    return eventDetailsProps
}
